import React from "react";
import { connect } from "react-redux";
import UI from "editor-ui-lib";
import Wix from "Wix";
import {setLayoutFile, setLayoutFolder} from '../../../../../actions/updateConnectActions';
import parameters from "../../../../../config/parameters";

import "./layout.scss";

import fileFullView from '../../../../../assets/file-full-view.svg';
import fileThumbnail from '../../../../../assets/file-thumbnail.svg';
import folderList from '../../../../../assets/folder-list.svg';
import folderThumbnails from '../../../../../assets/folder-thumbnails.svg';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.changeLayout = this.changeLayout.bind(this);
  }

  changeLayout(layoutName, value) {
    if(layoutName === 'select_layout') {
        this.props.setLayoutFolder(Number(value));
    } else {
        this.props.setLayoutFile(Number(value));
    }
  }
  renderCheckboxs() {
    return (
      <div  style={{marginBottom:'20px'}} >
        <UI.sectionDividerLabeled label={"Display Options"} />
        <hr className="divider-long"/>
        <div className="Label-for-checkboxes">{"Display file info"}</div>
        <UI.checkbox
          label="File type icon"
          defaultValue={true}
          wix-param='displayIcon'
          onChange={newVal => console.log(newVal)}
        />
        <UI.checkbox
          label="Owner name"
          defaultValue={true}
          wix-param='displayOwner'
          onChange={newVal => console.log(newVal)}
        />
        <UI.checkbox
          label="Last modified"
          defaultValue={true}
          wix-param='displayLastModified'
          onChange={newVal => console.log(newVal)}
        />
        {/* <hr className="divider-long"/> */}
      </div>
    );
  }

  rendrFolderLayout() {
    return (
      <div className="layout">
        <hr className="divider-long" />
        <UI.sectionDividerLabeled label={"Folder Layout"} />
        <hr className="divider-long" />
        <div style={{ display: 'none'}}>  
          <UI.thumbnails
              title={"Select folder layout"}
              activeDesign="vmark"
              wix-param={"select_layout2"}
              maxThumbsPerRow={3}
              options={[
                  { value: "1", label: "Thumbnails", src: folderThumbnails },
                  { value: "2", label: "List", src: folderList }
              ]}
              onChange={val => this.changeLayout("select_layout2", val)}>
          </UI.thumbnails>
        </div>
        <UI.thumbnails
            title={"Select folder layout"}
            //defaultValue={'1'}
            wix-param={"select_layout"}
            maxThumbsPerRow={3}
            options={[
                { value: "1", label: "Thumbnails", src: folderThumbnails },
                { value: "2", label: "List", src: folderList }
            ]}
            onChange={val => this.changeLayout("select_layout", val)}>
        </UI.thumbnails>
        {this.props.select_layout == 1 ?
                <div className="dropdown-size">
                    <hr className="divider-short"/>
                    <UI.dropDownSelect
                        defaultValue="1"
                        title="Thumbnail size"
                        wix-param="select_size"
                        options={[
                            { value: "1", label: "Large" },
                            { value: "2", label: "Medium" },
                            { value: "3", label: "Small" }
                        ]}/>
                </div> : null
        }
        <hr className="divider-long" />
        {this.renderCheckboxs()}
        <hr className="divider-long" /> 
         <UI.toggleSwitch
          label={"Search bar"}
          defaultValue={true}
          wix-param={'displaySearchBar'}/>
        <hr className="divider-long" />
        <UI.toggleSwitch
          label={"Sort icon"}
          defaultValue={true}
          wix-param={'displaySortIcon'}/>
       </div>
    );
  }

  renderFileLayout() {
    return (
      <div>
        <hr className="divider-long" />
        <UI.sectionDividerLabeled label={"File Layout"} />
        <hr className="divider-long" />
        <UI.thumbnails
            title={"Select file layout"}
            wix-param={"layout_file"}
            onChange={(val) => {this.changeLayout("layout_file", val)}}
            maxThumbsPerRow={3}
            options={[
                { value: "1", label: "Full Preview", src: fileFullView },
                { value: "2", label: "Thumbnail", src: fileThumbnail }
            ]}>
        </UI.thumbnails>
        {
            this.props.layout_file == 1 ?
            null
            : 
            <div >
            <hr className="divider-long" />
                {this.renderCheckboxs()}
            </div>
        }
      </div>
    );
  }

  render() {
    return this.props.dataPublic && this.props.dataPublic.activeFileId ? (
      this.props.dataPublic.mimeType !== parameters['TYPE_FOLDER'] ?  (
        this.renderFileLayout()
      ) : (
        this.rendrFolderLayout()
      )
    ) : (
      this.renderFileLayout()
    );
  }
}

const mapDispatchToProps = dispatch => ({
    setLayoutFile: (layout_file) => dispatch(setLayoutFile(layout_file)),
    setLayoutFolder: (select_layout) => dispatch(setLayoutFolder(select_layout))
});

const mapStateToProps = state => ({
    select_layout: state.userConnectReducer.select_layout,
    layout_file: state.userConnectReducer.layout_file,
    dataPublic: state.dataPublicReducer.dataPublic
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/layout/layout.js